<template>
  <div class="place-self-center text-2xl"> Home </div>
</template>
